// config/app.js - Application Configuration
const appConfig = {
  app: {
    title: process.env.REACT_APP_TITLE || "RMA System",
    version: process.env.REACT_APP_VERSION || "1.0.0",
    environment: process.env.NODE_ENV || "development"
  },
  api: {
    // Updated to match your Django backend URL structure
    baseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:8003/api",
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000
  },
  ui: {
    theme: {
      primary: process.env.REACT_APP_PRIMARY_COLOR || "#007bff",
      secondary: process.env.REACT_APP_SECONDARY_COLOR || "#28a745",
      danger: process.env.REACT_APP_DANGER_COLOR || "#dc3545",
      background: process.env.REACT_APP_BACKGROUND_COLOR || "#f8f9fa"
    }
  },
  features: {
    demoMode: process.env.REACT_APP_DEMO_MODE === "true",
    enableNotifications: process.env.REACT_APP_ENABLE_NOTIFICATIONS !== "false"
  }
};

export default appConfig;